/**
 * Labstep
 *
 * @module models/entity
 * @desc Typescript export class for any entity
 */

import type { Link } from 'labstep-web/components/Layout/Links/types';
import { ICONS } from 'labstep-web/constants/icons';
import type {
  LockEntityInfo,
  PermissionEntityInfo,
} from 'labstep-web/models';
import { humanReadableDate } from 'labstep-web/services/date.service';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import { navigation } from 'labstep-web/services/navigation';

export class Entity {
  public static entityName: string;

  public static readonly idAttr: string = 'id';

  protected name!: string | null;

  public id!: string | number;

  public guid!: string;

  public created_at!: string;

  public updated_at!: string;

  public deleted_at!: string;

  public _lock_entity_info?: LockEntityInfo;

  public get lock_entity_info(): LockEntityInfo | undefined {
    return this._lock_entity_info;
  }

  public set lock_entity_info(lockEntityInfo:
    | LockEntityInfo
    | undefined) {
    this._lock_entity_info = lockEntityInfo;
  }

  public _permission_entity_info?: PermissionEntityInfo;

  public get permission_entity_info():
    | PermissionEntityInfo
    | undefined {
    return this._permission_entity_info;
  }

  public set permission_entity_info(permissionEntityInfo:
    | PermissionEntityInfo
    | undefined) {
    this._permission_entity_info = permissionEntityInfo;
  }

  display_name?: string | null;

  constructor(data: Partial<Entity> = {}) {
    Object.assign(this, data);
  }

  get entityName(): string {
    return 'entity';
  }

  public get idAttr(): string | number {
    return this[
      (this.constructor as typeof Entity).idAttr as 'id' | 'guid'
    ];
  }

  get displayName(): string | null {
    return this.display_name || this.name;
  }

  get printDeletedAtDate() {
    if (!this.deleted_at) {
      return '';
    }
    return `deleted on ${humanReadableDate(this.deleted_at)}`;
  }

  static getHumanReadableEntityName(
    plural?: boolean,
    capitalized?: boolean,
  ): string {
    return getHumanReadableEntityName(
      this.entityName,
      plural,
      capitalized,
    );
  }

  get entityIcon() {
    if (ICONS[this.entityName as keyof typeof ICONS].primary) {
      return ICONS[this.entityName as keyof typeof ICONS].primary;
    }
    return null;
  }

  get route(): Link['route'] | null {
    // FIXME Refactor into a router service helper
    // if (this.entityName === ExperimentWorkflow.entityName) {
    //   return {
    //     to: 'experiment_workflow_show',
    //     params: {
    //       id: this.id,
    //     },
    //   };
    // }
    return null;
  }

  get permaLinkUrl(): string {
    return navigation.get(
      'permalink_show',
      { token: this.guid },
      true,
    );
  }
}
